import React from 'react';
import ReactGA from 'react-ga4';
import { scan } from 'react-scan';

import { TRACKING_ID } from '../constants/ga4';
import { IS_PROD, IS_DEV } from '../constants/environment';
import AppProviders from './AppProviders';
import AppRenderer from './AppRenderer';
import './App.scss';

const App = () => {
    React.useEffect(() => {
        if (IS_PROD) {
            ReactGA.initialize(TRACKING_ID);
        } else if (IS_DEV) {
            scan({
                enabled: true,
            });
        }
    }, []);

    return (
        <AppProviders>
            <AppRenderer />
        </AppProviders>
    );
};

export default App;
